// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--nGXMh","button":"button--AmHHn","buttonWrapper":"buttonWrapper--CtwCx","toggledButton":"toggledButton--W7S84 button--AmHHn","content":"content--pyxHB"};